<template>
  <a-card :loading="loading" :bordered="false" :body-style="loading ? {} : { padding: 0 }">
    <div class="salesCard">
      <a-tabs
        size="small"
        :tab-bar-style="{ marginBottom: '24px' }"
        v-model:activeKey="activeKey"
        @change="getTypes"
      >
        <template #rightExtra>
          <div class="salesExtraWrap">
            <div class="salesExtra">
              <a :class="isActive('week')" @click="() => selectDate('week')">
                {{ t('dashboard.analysis.all-week') }}
              </a>
              <a :class="isActive('month')" @click="() => selectDate('month')">
                {{ t('dashboard.analysis.all-month') }}
              </a>
              <a :class="isActive('year')" @click="() => selectDate('year')">
                {{ t('dashboard.analysis.all-year') }}
              </a>
            </div>
            <a-range-picker
              style="width: 256px"
              :value="rangePickerValue"
              @change="handleRangePickerChange"
            />
          </div>
        </template>
        <a-tab-pane key="cz_price" tab="收款">
          <a-row type="flex">
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesBar">
                <bar :height="295" title="收款趋势" :data="salesData.list_cz" />
              </div>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesRank" v-for="obj in state.newRankData.list_cz">
                <h4 class="rankingTitle">门店收款排行</h4>
                <ul class="rankingList" style="height: 260px">
                  <li v-for="(item, i) in obj.rank" :key="item.index">
                    <span :class="['rankingItemNumber', { active: item.index <= 3 }]">
                      {{ item.index }}
                    </span>
                    <span class="rankingItemTitle" :title="item.name">
                      {{ item.name }}
                    </span>
                    <span class="rankingItemValue" v-if="obj.money">
                      {{ formatYuan(item.total) }}
                    </span>
                    <span class="rankingItemValue" v-else>{{ item.total }}</span>
                  </li>
                </ul>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(-1, obj.page_count)"
                >
                  上一页
                </a-button>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(1, obj.page_count)"
                >
                  下一页
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="cz_customer" tab="收款人数">
          <a-row type="flex">
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesBar">
                <bar :height="295" title="收款人数趋势" :data="salesData.list_cz" />
              </div>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesRank" v-for="obj in state.newRankData.list_cz">
                <h4 class="rankingTitle">门店收款排行</h4>
                <ul class="rankingList" style="height: 260px">
                  <li v-for="(item, i) in obj.rank" :key="item.index">
                    <span :class="['rankingItemNumber', { active: item.index <= 3 }]">
                      {{ item.index }}
                    </span>
                    <span class="rankingItemTitle" :title="item.name">
                      {{ item.name }}
                    </span>
                    <span class="rankingItemValue" v-if="obj.money">
                      {{ formatYuan(item.total) }}
                    </span>
                    <span class="rankingItemValue" v-else>{{ item.total }}</span>
                  </li>
                </ul>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(-1, obj.page_count)"
                >
                  上一页
                </a-button>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(1, obj.page_count)"
                >
                  下一页
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="used_price" tab="耗单">
          <a-row type="flex">
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesBar">
                <bar :height="292" title="耗单趋势" :data="salesData.list_cz" />
              </div>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesRank" v-for="obj in state.newRankData.list_cz">
                <h4 class="rankingTitle">门店耗单排行</h4>
                <ul class="rankingList" style="height: 260px">
                  <li v-for="(item, i) in obj.rank" :key="item.index">
                    <span :class="['rankingItemNumber', { active: item.index <= 3 }]">
                      {{ item.index }}
                    </span>
                    <span class="rankingItemTitle" :title="item.name">
                      {{ item.name }}
                    </span>
                    <span class="rankingItemValue" v-if="obj.money">
                      {{ formatYuan(item.total) }}
                    </span>
                    <span class="rankingItemValue" v-else>{{ item.total }}</span>
                  </li>
                </ul>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(-1, obj.page_count)"
                >
                  上一页
                </a-button>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(1, obj.page_count)"
                >
                  下一页
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="used_customer" tab="耗单人数">
          <a-row type="flex">
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesBar">
                <bar :height="292" title="耗单人数趋势" :data="salesData.list_cz" />
              </div>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <div class="salesRank" v-for="obj in state.newRankData.list_cz">
                <h4 class="rankingTitle">门店耗单排行</h4>
                <ul class="rankingList" style="height: 260px">
                  <li v-for="(item, i) in obj.rank" :key="item.index">
                    <span :class="['rankingItemNumber', { active: item.index <= 3 }]">
                      {{ item.index }}
                    </span>
                    <span class="rankingItemTitle" :title="item.name">
                      {{ item.name }}
                    </span>
                    <span class="rankingItemValue" v-if="obj.money">
                      {{ formatYuan(item.total) }}
                    </span>
                    <span class="rankingItemValue" v-else>{{ item.total }}</span>
                  </li>
                </ul>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(-1, obj.page_count)"
                >
                  上一页
                </a-button>
                <a-button
                  size="small"
                  style="width: 50%"
                  type="link"
                  @click="changePage(1, obj.page_count)"
                >
                  下一页
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="customer_avg" tab="人均">
          <a-row type="flex">
            <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
              <div>
                <line :height="292" title="人均趋势" :data="salesData.list_cz" />
              </div>
            </a-col>
            <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
              <a-tabs v-model:rankActiveKey="rankActiveKey">
                <a-tab-pane
                  :key="obj.name"
                  :tab="obj.name"
                  v-for="obj in state.newRankData.list_cz"
                >
                  <div class="salesRank">
                    <h4 class="rankingTitle">人均排行</h4>
                    <ul class="rankingList" style="height: 260px">
                      <li v-for="(item, i) in obj.rank" :key="item.index">
                        <span :class="['rankingItemNumber', { active: item.index <= 3 }]">
                          {{ item.index }}
                        </span>
                        <span class="rankingItemTitle" :title="item.name">
                          {{ item.name }}
                        </span>
                        <span class="rankingItemValue" v-if="obj.money">
                          {{ formatYuan(item.total) }}
                        </span>
                        <span class="rankingItemValue" v-else>{{ item.total }}</span>
                      </li>
                    </ul>
                    <a-button
                      size="small"
                      style="width: 50%"
                      type="link"
                      @click="changePage(-1, obj.page_count)"
                    >
                      上一页
                    </a-button>
                    <a-button
                      size="small"
                      style="width: 50%"
                      type="link"
                      @click="changePage(1, obj.page_count)"
                    >
                      下一页
                    </a-button>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, watch, PropType, onMounted, onUpdated } from 'vue';
import { Bar } from './charts';
import { Line } from './charts';
import { useI18n } from 'vue-i18n';
import numeral from 'numeral';

export interface RankingDataItem {
  title: string;
  total: number | string;
}

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Function as PropType<(type: any) => void>,
      default: () => {
        return undefined;
      },
    },
    getTypes: {
      type: Function,
      default: () => {
        return undefined;
      },
    },
    selectDate: {
      type: Function as PropType<(type: any) => void>,
      default: () => {
        return undefined;
      },
    },
    handleRangePickerChange: {
      type: Function,
      default: () => {
        return undefined;
      },
    },
    rangePickerValue: {
      type: Array as PropType<RankingDataItem[]>,
      required: true,
    },
    salesData: {
      type: Object,
      required: true,
    },
    rankData: {
      type: Object,
      required: true,
    },
  },
  setup(props: any) {
    const { t, locale } = useI18n();
    const activeKey = ref('cz_price');
    const rankActiveKey = ref('');
    const state = reactive({
      rankingListData: [] as RankingDataItem[],
      newRankData: {
        list_cz: [] as any[],
      },
      page_index: 1,
      page_size: 7,
    });
    const formatYuan = (val: string | number) => `¥ ${numeral(val).format('0,0')}`;
    const readData = () => {
      state.page_index = 1;
      state.page_size = 7;
      loadData();
    };
    const loadData = () => {
      state.newRankData.list_cz = [];
      props.rankData.list_cz.map((obj: any) => {
        let new_obj = Object.assign({}, obj);
        let start_node = (state.page_index - 1) * state.page_size;
        let end_node = state.page_index * state.page_size;
        new_obj.data_count = obj.rank.length;
        new_obj.page_count = Math.ceil(obj.rank.length / state.page_size);
        new_obj.rank = obj.rank.filter((item: any, index: any) => {
          return start_node <= index && index < end_node;
        });
        state.newRankData.list_cz.push(new_obj);
      });
    };
    const changePage = (type: any, page_count: any) => {
      if (state.page_index > 1 && type == -1) {
        state.page_index -= 1;
      } else if (state.page_index + 1 <= page_count && type == 1) {
        state.page_index += 1;
      }
      loadData();
    };
    const generatorRankingData = () => {
      state.rankingListData = [];
      for (let i = 0; i < 7; i += 1) {
        state.rankingListData.push({
          title: t('dashboard.analysis.test', { no: i }),
          total: 323234,
        });
      }
    };

    onMounted(() => {
      generatorRankingData();
      loadData();
      watch(
        () => locale.value,
        () => {
          generatorRankingData();
          loadData();
        },
      );
    });

    onUpdated(() => {
      readData();
    });

    return {
      t,
      numeral,
      state,
      activeKey,
      rankActiveKey,
      formatYuan,
      changePage,
    };
  },
  components: {
    Bar,
    Line,
  },
});
</script>

<style lang="less" scoped>
@import '../style.less';
</style>
